export default class AreaSelector {
	constructor(layer, scale) {
		this._scale = scale;
		this._callbacks = {};
		this._createBrush(layer);
	}

	_createBrush(layer) {
		this._el = d3.select(layer);
		let currentSelection;
		const brush = this._brush = d3.brush()
			.keyModifiers(false)
			.on("start", () => {
				if (typeof this._callbacks["start"] === "function")
					typeof this._callbacks["start"](currentSelection = d3.event.selection, d3.event.sourceEvent)
			})
			.on("brush", () => {
				if (typeof this._callbacks["select"] === "function")
					typeof this._callbacks["select"](currentSelection = d3.event.selection, d3.event.sourceEvent)
			})
			.on("end", () => {
				if (typeof this._callbacks["end"] === "function")
					typeof this._callbacks["end"](currentSelection, d3.event.sourceEvent)
				this._el.call(d3.brush().move, [[-100, -100], [-100, -100]])
			});
		this._el.call(brush);
	}

	on(eventName, cb) {
		this._callbacks[eventName] = cb;
	}

	onScaleChanged() {
		this._el.call(this._brush.extent([[0, 0], [Math.max(0, this._scale.x.range[1]), Math.max(0, this._scale.y.range[0])]]))
	}
}